export enum BusinessImageType {
  Banner = 'banner',
  Logo = 'logo',
}
